import { IProductQuery } from "../../models/product/query";
import { IProduct, IProductDetails, IQuantity } from "../../models/product/response";
import IBaseListingResponse from "../../utils/api/base-listing-response";
import toggleLoading from "../../utils/helpers/xor";
import paramsReducer from "../base/base-reducer";
import { QueryAction } from "../base/base-reducer";
import { IInternalState, ProductLoading } from "./context";

type Action =
  | { type: "LOADING"; payload: { loading: ProductLoading | ProductLoading[] } }
  | { type: "SET_LIST"; payload: { list: IBaseListingResponse<IProduct> } }
  | { type: "SET_DETAILS"; payload: { details?: IProductDetails } }
  | { type: "SET_QUANTITIES"; payload: { quantities?: IQuantity[] } }
  | QueryAction<IProductQuery>;

const reducer = (state: IInternalState, action: Action): IInternalState => {
  switch (action.type) {
    case "LOADING": {
      return {
        ...state,
        loading: toggleLoading(state.loading, action.payload.loading),
      };
    }
    case "SET_LIST": {
      return {
        ...state,
        list: action.payload.list,
      };
    }

    case "SET_DETAILS": {
      return {
        ...state,
        details: action.payload.details,
      };
    }
    case "SET_QUANTITIES": {
      return {
        ...state,
        quantities: action.payload.quantities,
      };
    }

    default: {
      return paramsReducer(state, action);
    }
  }
};

export default reducer;
